import React from 'react'
import { Link } from "react-router-dom";


const DetailsBlog = () => {
    return (
        <>

            <div className="site-breadcrumb" style={{ background: 'url(assets/school/about.webp)' }}>
                <div className="container">
                    <h2 className="breadcrumb-title">Details Blog</h2>
                    <ul className="breadcrumb-menu">
                        <li><Link to="/">Home</Link></li>
                        <li className="active" style={{ color: "red" }}>Details Blog</li>
                    </ul>
                </div>
            </div>

            <div className="blog-single-area pt-120 pb-120">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="blog-single-wrapper">
                                <div className="blog-single-content">
                                    <div className="blog-thumb-img">
                                        <img src="assets/school/banner_9.webp" alt="thumb" />
                                    </div>
                                    <div className="blog-info">
                                        <div className="blog-details">
                                            <h3 className="blog-details-title mb-20">Saraswati Puja Celebration in Our School</h3>
                                            <p className="mb-10">
                                                Saraswati Puja was celebrated with great devotion, enthusiasm, and cultural spirit in our school. The festival, dedicated to Goddess Saraswati, the goddess of knowledge, wisdom, learning, music, and art, holds a special place in the hearts of students and teachers alike.
                                            </p>
                                            <p className="mb-10">
                                                <b style={{color:"black"}}>Significance of Saraswati Puja: </b>
                                                Saraswati Puja symbolizes the importance of education and enlightenment. On this auspicious day, students seek blessings from Goddess Saraswati for success in academics, creativity, and moral values. The festival inspires learners to respect books, knowledge, and teachers.
                                            </p>
                                            <p>
                                                <b style={{color:"black"}}>Celebration at School: </b>
                                                The school campus was beautifully decorated with flowers, rangoli, and traditional motifs. A graceful idol of Goddess Saraswati was installed in the prayer hall. Teachers and students dressed in traditional attire, mainly in yellow, which represents wisdom and prosperity.

                                                The puja ceremony was performed with proper rituals, chanting of mantras, and offering of flowers, fruits, and sweets. Students placed their books, notebooks, pens, and musical instruments near the idol, seeking divine blessings for a bright academic future.
                                            </p>
                                            <blockquote className="blockqoute">
                                                The Saraswati Puja celebration created an atmosphere of peace, devotion, and positivity throughout the school. It strengthened the bond between students and teachers and reminded everyone that knowledge is the greatest wealth.
                                                <h6 className="blockqoute-author">Conclusion</h6>
                                            </blockquote>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </>
    )
}

export default DetailsBlog